import React from 'react';
import { RobRowStyle } from './BunkerRob.styles';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { FuelRobVM } from 'src/types/ViewModel/Bunkering/FuelRobVM';
import { useBunkerContext } from 'src/context/BunkerContext';
import { hasConsOrLossForTankAndBunkering } from '../BunkeringUtils';

interface TankContentRowsProps {
    tank: Tank;
    tankNameColumn: boolean;
    contentsInTank: Bunkering[];
    fuelRobVM: FuelRobVM;
}

const TankContentRows: React.FC<TankContentRowsProps> = ({ tank, tankNameColumn, contentsInTank, fuelRobVM }) => {
    const { bunkerings } = useBunkerContext();
    const bunkeringIdsInCurrentColumn = fuelRobVM?.fuelRobColumns
        ?.flatMap((column) => column.fuelRobs)
        .filter((r) => r.tankId === tank.tankId)
        .map((rob) => rob.bunkeringGuid);
    const bunkeringsInCurrentColumn = bunkerings.filter((bunkering) => bunkeringIdsInCurrentColumn.includes(bunkering.bunkeringGuid));
    contentsInTank = Array.from(new Set(bunkeringsInCurrentColumn.concat(contentsInTank))).sort((a, b) =>
        a.bunkeringGuid.localeCompare(b.bunkeringGuid)
    );

    if (!contentsInTank || contentsInTank.length === 0) {
        return <RobRowStyle key={`${tank.tankId}`}>{tankNameColumn ? tank.tankName : 'Empty'}</RobRowStyle>;
    }

    return (
        <>
            {contentsInTank.map((content, i) => (
                <RobRowStyle
                    key={`${tank.tankId}_${content.bunkeringGuid}_${tankNameColumn ? 0 : 1}`}
                    hideBorderBottom={contentsInTank.length > 1 && tankNameColumn && i < contentsInTank.length}
                    hasConsumption={hasConsOrLossForTankAndBunkering(tank.tankId, content.bunkeringGuid, fuelRobVM)}
                >
                    {tankNameColumn ? (contentsInTank.length === 1 || i === 0) && tank.tankName : content.bunkeringReference}
                </RobRowStyle>
            ))}
            {contentsInTank.length > 1 && <RobRowStyle key={`${tank.tankId}_empty`}>{tankNameColumn ? '' : 'Total in tank:'}</RobRowStyle>}
        </>
    );
};

export default TankContentRows;
